export function excludeTouch<E>(
  eventHandler: (event: React.PointerEvent<E>) => void
) {
  return (event: React.PointerEvent<E>) =>
    event.pointerType === 'touch' ? undefined : eventHandler(event)
}
